// apps/client/src/game/testFinders/fishing.ts (M1-T15) — `__wt.find('shadow')`: your fish shadow nearest `near`.
import type { TestFinder } from '../testHooks';
import { fishingLayerOf } from '../../world/fishing';
export const finders: readonly TestFinder[] = [{
  kind: 'shadow',
  find(game, near) {
    const list = [...(fishingLayerOf(game)?.shadows() ?? [])];
    if (near) list.sort((a, b) => Math.hypot(a.x - near.x, a.y - near.y) - Math.hypot(b.x - near.x, b.y - near.y));
    const s = list[0];
    return s ? { id: s.id, x: s.x, y: s.y } : null;
  },
}];
